module.exports = __webpack_public_path__ + "static/pokoj-nr1-photo05-60514a7f837e3831669b86d6e1846f85.jpg";